import { render, staticRenderFns } from "./LangToggle.vue?vue&type=template&id=90be68b2&scoped=true&"
import script from "./LangToggle.vue?vue&type=script&lang=js&"
export * from "./LangToggle.vue?vue&type=script&lang=js&"
import style0 from "./LangToggle.vue?vue&type=style&index=0&id=90be68b2&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90be68b2",
  null
  
)

export default component.exports